<template>
  <div style="padding: 5px">
    <a-spin tip="Loading..." :spinning="loading">
      <a-icon slot="indicator" type="loading" />
      <div style="margin-bottom: 10px; text-align: right">
        <a-button v-if="data.length > 0" icon="export" @click="onExport">
          Export
        </a-button>
      </div>
      <div class="spin-content">
        <table id="export-employee" class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" rowspan="2">#</th>
              <th scope="col" rowspan="2">Code</th>
              <th scope="col" rowspan="2">Fullname</th>
              <th scope="col" rowspan="2">Department</th>
              <th scope="col" rowspan="2">Position</th>
              <th scope="col" rowspan="2">Location</th>
              <th scope="col" rowspan="2">Main shift</th>
              <th scope="col" rowspan="2">Phone</th>
              <th scope="col" rowspan="2">Email</th>
              <th scope="col" rowspan="2">Code Department</th>
              <th scope="col" rowspan="2">Cost Center</th>
              <th scope="col" rowspan="2">Started date</th>
              <th scope="col" rowspan="2">Gender</th>
              <th scope="col" rowspan="2">Birthday</th>
              <th scope="col" rowspan="2">Department</th>
              <th scope="col" rowspan="2">Position</th>
              <th scope="col" rowspan="2">Account</th>
              <th scope="col" colspan="4">Annual leave</th>
            </tr>
            <tr>
              <th scope="col">Original</th>
              <th scope="col">Default</th>
              <th scope="col">Used</th>
              <th scope="col">Remain</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(employee, idx) in data" :key="employee.id">
              <th scope="row">{{ idx + 1 }}</th>
              <td>{{ employee.code }}</td>
              <td>{{ employee.fullname }}</td>
              <td>{{ employee.department && employee.department.name }}</td>
              <td>{{ employee.position && employee.position.name }}</td>
              <td>
                {{ employee.branchLocation && employee.branchLocation.name }}
              </td>
              <td>{{ employee.workShift && employee.workShift.title }}</td>
              <td>
                {{ employee.phone ? JSON.stringify(employee.phone) : "" }}
              </td>
              <td>{{ employee.email }}</td>
              <td>{{ employee.codeDepartment }}</td>
              <td>{{ employee.costCenter }}</td>
              <td>
                {{ employee.startedDate | formatDateCustom("MMMM DD YYYY") }}
              </td>
              <td>{{ employee.gender }}</td>
              <td>
                {{ employee.birthday | formatDateCustom("MMMM DD YYYY") }}
              </td>
              <td>
                <span v-if="employee.user">
                  {{ employee.user.fullname }} ({{ employee.user.email }})
                </span>
              </td>
              <td>
                <span v-if="employee.annualLeaveDay">
                  {{
                    (employee.annualLeaveDay.original /
                      getDurationShiftEmployee(employee))
                      | numParseFloat(2)
                  }}
                </span>
              </td>
              <td>
                <span v-if="employee.annualLeaveDay">
                  {{
                    (employee.annualLeaveDay.default /
                      getDurationShiftEmployee(employee))
                      | numParseFloat(2)
                  }}
                </span>
              </td>
              <td>
                <span v-if="employee.annualLeaveDay">
                  {{
                    (employee.annualLeaveDay.usedInYear /
                      getDurationShiftEmployee(employee))
                      | numParseFloat(2)
                  }}
                </span>
              </td>
              <td>
                <span v-if="employee.annualLeaveDay">
                  {{
                    (employee.annualLeaveDay.remain /
                      getDurationShiftEmployee(employee))
                      | numParseFloat(2)
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-spin>
  </div>
</template>
<script>
import moment from "moment";
import viewExportExcelService from "@/services/viewExportExcel.js";
import { formatCell } from "./services/export-style";

import query from "./data/getData";

const limit = 100;
const startPage = 1;

function getDurationShiftEmployee(employee) {
  return (
    employee?.workShift?.duration ||
    employee?.branchLocation?.mainShift?.duration ||
    1
  );
}

export default {
  components: {},
  data() {
    return {
      data: [],
      loading: false,
      page: startPage,
    };
  },
  computed: {
    exportFileName() {
      return new moment().format("DD_MM_YYY_HHmmss") + "_employee";
    },
  },
  async created() {
    await this.getListPagination(this.page);
    await this.onExport();
    window.close();
  },
  methods: {
    getDurationShiftEmployee,
    getAllEmployee(currentPage) {
      return this.$apollo.query({
        query: query.queryGetAllEmployee,
        variables: {
          limit,
          page: currentPage,
        },
        fetchPolicy: "no-cache",
      });
    },
    async getListPagination(currentPage) {
      try {
        this.loading = true;
        const { data } = await this.getAllEmployee(currentPage);
        if (data?.getAllEmployee?.length > 0) {
          this.data = (this.data || []).concat(data.getAllEmployee);
        }
        if (data?.getAllEmployee?.length === limit) {
          await this.getListPagination(currentPage + 1);
        }
        this.loading = false;
      } catch (err) {
        console.error("Error", err);
      }
    },
    async onExport() {
      try {
        await viewExportExcelService({
          filename: this.exportFileName,
          tableId: "export-employee",
          formatCellFnc: (sheets) => {
            formatCell(sheets);
          },
        });
      } catch (err) {
        console.error("Error export", err);
      }
    },
  },
};
</script>
